import { withLazy } from 'app/hocs/withLazy'

export const Payment = withLazy(() => import('features/Payment/pages/Payment'))
